// #region Force referrer
$(document).on("click", ".force_referrer", (e) => {
    e.preventDefault();
    window.location.href = document.referrer || "/collections/all";
});
// #endregion Force referrer

// #region Scroll to gift wrap from drawer gift button click
const isCartPage = location.pathname.includes("/cart");
const shouldScroll = location.search.includes("hl=", "");
let splitLoc;
let highlightName;

if (shouldScroll) {
    splitLoc = location.search.replace("?", "").split("&");
    highlightName = splitLoc
        .find((item) => item.includes("hl="))
        .replace("hl=", "");
}

function highlightElem(elementToHighlight$) {
    elementToHighlight$.addClass("r-highlight");
    setTimeout(() => {
        elementToHighlight$.removeClass("r-highlight");
    }, 1000);
}

function scrollToAndHighlight(
    elementToScrollTo$,
    elementToHighlight$ = elementToScrollTo$,
    time = 1000,
    callback
) {
    if (!elementToScrollTo$) return;

    $("html,body").animate(
        {
            scrollTop: elementToScrollTo$.offset().top - $(window).height() / 2,
        },
        time,
        () => {
            highlightElem(elementToHighlight$);
            callback && callback();
        }
    );
}

if (isCartPage) {
    $(".shopify-section .cart--giftwrap-button").removeAttr("href");

    $(document).on(
        "click",
        ".drawer--container .cart--giftwrap-button",
        (e) => {
            e.preventDefault();
            $(".drawer--close").trigger("click");
            $("#giftItToggle").trigger("click");
        }
    );

    $(document).on(
        "click",
        ".shopify-section .cart--giftwrap-button",
        (e) => {
            $("#giftItToggle").trigger("click");
        }
    );
}

if (isCartPage && shouldScroll) {
    const scrollInterval = setInterval(() => {
        const elementToScrollTo$ = $(
            `[data-highlight="${highlightName}"`
        )?.get(0);

        if (shouldScroll && elementToScrollTo$) {
            scrollToAndHighlight(
                elementToScrollTo$,
                $(".cart--giftwrap-button"),
                0,
                () => {
                   // Get the current URL
            let currentUrl = window.location.href;
            
            // Remove the 'hl' parameter
            let newUrl = removeQueryStringParameter(currentUrl, 'hl');
            
            // Update the URL in the browser without reloading the page
            window.history.replaceState({}, document.title, newUrl);
                    $("#giftItToggle").trigger("click");
                }
            );
            clearInterval(scrollInterval);
        }
    }, 200);
}
// #endregion Scroll to gift wrap from drawer gift button click

let customLangToggler$ = $(".custom-lang-toggler");

// When the Hextom dropdown is loaded
const hextomInterval = setInterval(() => {
    const unselectedItem$ = $(
        ".ht-tms-single-dropdown__dropdown-wrapper .ht-tms-option__text[data-value]"
    );

    if (unselectedItem$.text()) {
        const isUnselectedEnglish = unselectedItem$
            .text()
            .toLowerCase()
            .includes("english");

        // Hide mobile language selector on clicking X
        let customLangTogglerMobile$ = $(
            ".custom-lang-toggler-wrapper--mobile"
        );
        let customLangTogglerMobileClose$ = $(
            ".custom-lang-toggler-wrapper--mobile .close-button"
        );

        if (!sessionStorage.getItem("activeLang")) {
            customLangTogglerMobile$.removeClass("lang-fade-out");
        }

        customLangTogglerMobileClose$.on("click", () => {
            customLangTogglerMobile$.addClass("lang-fade-out");
        });

        // Set 'click' event to custom toggler to trigger the item that's in the Hextom dropdown
        $(document).on("click", ".custom-lang-toggler", function () {
            sessionStorage.setItem(
                "activeLang",
                isUnselectedEnglish ? "en" : "ar"
            );
            unselectedItem$.click();
            customLangTogglerMobile$.addClass("lang-fade-out");
        });

        $(document).on("click", ".button-ar", function () {
            sessionStorage.setItem("activeLang", "ar");
            !isUnselectedEnglish && unselectedItem$.click();
            customLangTogglerMobile$.addClass("lang-fade-out");
        });

        $(document).on("click", ".button-en", function () {
            sessionStorage.setItem("activeLang", "en");
            isUnselectedEnglish && unselectedItem$.click();
            customLangTogglerMobile$.addClass("lang-fade-out");
        });

        // Set toggler text based on unselected item
        customLangToggler$.text(unselectedItem$.text());

        // Add footer language selector
        const footerLangDropdownHTML = `
        <select lang="ar" class="footer-custom-language-selector">
            <option value="en" ${!isUnselectedEnglish ? "selected" : ""
            }>English</option>
            <option value="ar" lang="ar" style="direction: ltr;" ${isUnselectedEnglish ? "selected" : ""
            }>العربية</option>
        </select>
    `;

        $(".footer--sub").before(footerLangDropdownHTML);
        $(document).on("change", ".footer-custom-language-selector", (e) => {
            const selectedLang = $(e.target).val();
            sessionStorage.setItem(
                "activeLang",
                selectedLang === "en" ? "en" : "ar"
            );
            unselectedItem$.click();
        });

        clearInterval(hextomInterval);
    }
}, 50);

// #region Remove Arabic AED currency
function removeArabicAED() {
    const elemsWithArabicCurrency$ = $(
        'li:contains("د.إ"), span:contains("د.إ"), p:contains("د.إ")'
    );

    elemsWithArabicCurrency$.each((index, elem) => {
        const elem$ = $(elem);
        if (elem$.is(".product--price, .money")) {
            elem$.text(elem$.text().replaceAll("د.إ", ""));
        }

        if (elem$.is(".navigation--active-tag")) {
            elem$.text(elem$.text().replaceAll("د.إ", "AED "));
        }

        if (elem$.is(".price-range--currency")) {
            elem$.text(elem$.text().replaceAll("د.إ", "AED"));
        }

        if (elem$.is(".Polaris-Text--root")) {
            const currentText =
                elem$.text().replaceAll("د.إ", "").trim() + " AED";
            elem$.text(currentText);
        }
    });
}

           function removeQueryStringParameter(url, parameter) {
                // Split the URL into base URL and query string
                let [baseUrl, queryString] = url.split('?');
                if (!queryString) {
                    return url; // No query string present
                }
                
                // Split the query string into individual parameters
                let params = queryString.split('&');
                
                // Filter out the parameter to be removed
                params = params.filter(param => !param.startsWith(parameter + '='));
                
                // Reconstruct the query string
                let newQueryString = params.length > 0 ? '?' + params.join('&') : '';
                
                // Return the new URL
                return baseUrl + newQueryString;
            }

function removeEnglishAED() {
    const elemsWithArabicCurrency$ = $(
        'li:contains("AED"), span:contains("AED"), p:contains("AED")'
    );

    elemsWithArabicCurrency$.each((index, elem) => {
        const elem$ = $(elem);
        if (elem$.is(".product--price, .money")) {
            elem$.text(elem$.text().replaceAll("AED", ""));
        }

        if (elem$.is(".navigation--active-tag")) {
            elem$.text(elem$.text().replaceAll(" AED ", "د.إ"));
        }

        if (elem$.is(".price-range--currency")) {
            elem$.text(elem$.text().replaceAll("AED", "د.إ"));
        }

        if (elem$.is(".Polaris-Text--root")) {
            const currentText =
                elem$.text().replaceAll("AED", "").trim() + "د.إ";
            elem$.text(currentText);
        }
    });
}
// #endregion Remove Arabic AED currency

// #region Ramy - JS - Common
const mainInterval = setInterval(() => {
    if (!isArabicSite) {
        removeArabicAED();
    }

    if (isArabicSite) {
        removeEnglishAED();
    }
}, 50);

setTimeout(() => {
    clearInterval(mainInterval);
}, 7000);
// #endregion Ramy - JS - Common

// #region apply same size on complete the look
// const sizeOptions = document.querySelectorAll('div[option-name="Size"] .swatch-view-item');

// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     // Get all size option elements
//     const sizeOptions = document.querySelectorAll('div[option-name="Size"] .swatch-view-item');
//     console.log(sizeOptions,' this is the sizes')

//     // Ensure the elements are available before adding event listeners
//     if (sizeOptions.length > 0) {
//       sizeOptions.forEach(option => {
//         option.addEventListener("click", () => {
//           // Get the size value from the clicked element
//           const selectedSize = option.getAttribute("orig-value");

//           // Save the selected size in sessionStorage
//           sessionStorage.setItem("selectedSize", selectedSize);

//           console.log(`Selected size: ${selectedSize}`); // Debugging log
//         });
//       });
//     } else {
//       console.error('Size options not found.');
//     }
//   }, 1500); // Delay to give the page more time to load
// });

document.addEventListener("DOMContentLoaded", () => {
    // Function to get the query parameter from the URL
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Get the 'size' parameter from the URL
  const selectedSizeFromUrl = getUrlParameter('size');
  
  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(() => {
    const sizeOptions = document.querySelectorAll('div[option-name="Size"] .swatch-view-item');
    
    if (sizeOptions.length > 0) {
      // Stop observing once the elements are found
      observer.disconnect();

      sizeOptions.forEach(option => {
        option.addEventListener("click", () => {
          // Get the size value from the clicked element
          const selectedSize = option.getAttribute("orig-value");

          // Save the selected size in sessionStorage
          // sessionStorage.setItem("selectedSize", selectedSize);
          
          // Adjust recommendation products url
          const productsRecommendation =  document.querySelectorAll('.related-products--root .complete-the-look a');


          productsRecommendation.forEach(prod => {
              // Modify the URL of each anchor tag
              const currentUrl = prod.getAttribute('href');

              // Check if the URL already contains the 'size' parameter
                const url = new URL(currentUrl, window.location.origin);
              
                // If the 'size' parameter already exists, update its value
                if (url.searchParams.has("size")) {
                  url.searchParams.set("size", selectedSize);
                } else {
                  // If the 'size' parameter doesn't exist, add it
                  url.searchParams.append("size", selectedSize);
                }
              
              // // Modify the URL, for example, adding a query parameter or changing the path
              // const newUrl = currentUrl + `&size=${selectedSize}`; // Example: appending a query parameter
              
              // Update the 'href' attribute with the new URL
                 prod.setAttribute("href", url.toString());
          })
          
        });
      });

        // If the 'size' parameter exists in the URL
        if (selectedSizeFromUrl != null && selectedSizeFromUrl.length > 0) {      
          // Loop through the size options and select the matching size
          sizeOptions.forEach(option => {
            const sizeValue = option.getAttribute("orig-value");
      
            // If the option's size matches the one in the URL, simulate a click on it
            if (sizeValue.toLowerCase() === selectedSizeFromUrl.toLowerCase()) {
              option.click();  // This simulates the click event and triggers the selection
            }
          });
        }
    }
  });

  // Start observing changes in the DOM
  observer.observe(document.body, { childList: true, subtree: true });

  // Set a timeout to disconnect the observer after a period (e.g., 5 seconds) if elements are not found
  setTimeout(() => observer.disconnect(), 5000); // Disconnect after 5 seconds
});


// #endregion